import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CatalogBreadcrumb, CatalogMetadata, ProductCard } from '@/components/catalog'
import { NotFound } from '@/components/layout/SiteShell'
import { publicCategories, publicProducts } from '@/data/public-catalog'
import { languageFromPath } from '@/i18n/routes'
import { contentRoutes } from '@/i18n/content-routes'

export function CategoryPage() {
  const { t } = useTranslation('common')
  const location = useLocation()
  const language = languageFromPath(location.pathname)
  const normalizedPath = location.pathname.replace(/\/$/, '')
  const route = contentRoutes.find(item => item.type === 'category' && item[language] === normalizedPath)
  const category = publicCategories.find(item => item.id === route?.id)
  if (!route || !category) return <NotFound />

  const fixtureEmpty = import.meta.env.DEV && new URLSearchParams(location.search).get('catalogFixture') === 'empty'
  const products = fixtureEmpty ? [] : publicProducts.filter(product => product.categoryId === category.id)
  const title = t(`categories.${category.id}`)
  const verifiedDescription = category.id === 'cat-traceability'
  const description = verifiedDescription ? t('catalog.traceabilityDescription') : t('catalog.descriptionUnavailable')
  return <div className="catalog-page catalog-category-page">
    <CatalogMetadata
      language={language}
      title={title}
      description={t('catalog.categoryMetaDescription', { category: title, count: products.length })}
      canonicalPath={route[language]}
      alternatePaths={{ it: route.it, en: route.en }}
    />
    <header className="catalog-page-header internal-hero">
      <div className="shell-container">
        <CatalogBreadcrumb current={title} />
        <div className="catalog-heading-grid">
          <h1 tabIndex={-1}>{title}</h1>
          <div>
            <p className="catalog-category-description">{description}</p>
            {verifiedDescription && language === 'en' && <p className="catalog-source-status">{t('catalog.translatedDescriptionStatus')}</p>}
            {!category.languages[language] && <p className="catalog-source-status">{t('catalog.categoryLanguageFallback')}</p>}
          </div>
        </div>
      </div>
    </header>
    <section className="shell-container catalog-section" aria-labelledby="category-products-title">
      <div className="catalog-section-heading catalog-section-heading--count">
        <h2 id="category-products-title">{t('catalog.productsTitle')}</h2>
        <p aria-live="polite">{t('catalog.productCount', { count: products.length })}</p>
      </div>
      {products.length > 0
        ? <div className="catalog-product-grid">{products.map(product => <ProductCard key={product.id} product={product} language={language} categoryPath={normalizedPath} />)}</div>
        : <div className="catalog-empty"><h3>{t('catalog.emptyTitle')}</h3><p>{t('catalog.emptyDescription')}</p></div>}
    </section>
  </div>
}
